import React from 'react';
import { AppButton } from '../../ui';
import { koikispassAgendaUrl } from './magazineHelpers';

function KoikispassDateLink({ row, children = null, size = 'sm', variant = 'outline-secondary' }) {
  const href = koikispassAgendaUrl(row);
  if (!href) {
    return null;
  }

  return (
    <AppButton
      as="a"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      size={size}
      variant={variant}
      icon="mdi:open-in-new"
      aria-label={children ? undefined : 'Voir sur Koikispass'}
      title="Voir la date sur Koikispass"
      onClick={(event) => event.stopPropagation()}
    >
      {children}
    </AppButton>
  );
}

export default KoikispassDateLink;
